// Create a theme instance.
const theme = {
  palette: {
    primary: {
      main: "#17479E",
    },
    secondary: {
      main: "#19857b",
    },
    gray: "#808285",
  },
  width: {
    mainLayoutWidth: "1232px",
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,
      1058: 1058,
      376: 376,
      769: 769,
    },
  },
  components: {
    // Name of the component
    MuiContainer: {
      styleOverrides: {
        // Name of the slot
        root: ({ ownerState, theme }) => ({
          [theme.breakpoints.up("xl")]: {
            paddingLeft: 0,
            paddingRight: 0,
          },
          [theme.breakpoints.up("sm")]: {
            paddingLeft: 16,
            paddingRight: 16,
          },
        }),
      },
    },
    MuiPickersArrowSwitcher: {
      styleOverrides: {
        // Name of the slot
        root: () => ({
          flexFlow: "row-reverse",
        }),
      },
    },
    MuiInputLabel: {
      defaultProps: {
        sx: {
          fontSize: 14,
        },
      },
    },
    MuiOutlinedInput: {
      defaultProps: {
        sx: {
          fontSize: 14,
        },
      },
    },
  },

  // components: {
  //   MuiCssBaseline: {
  //     styleOverrides: themeParam => `
  //
  //
  //       // h1 {
  //       //   color: ${themeParam.palette.primary.main}; // use variable
  //       // }
  //     `,
  //   },
  // },
};

export default theme;
